// extracted by mini-css-extract-plugin
module.exports = {"offCanvas":"HeaderSortFilter_offCanvas__3Lrfz","selector":"HeaderSortFilter_selector__3LokZ"};